// Tower helper utilities

export interface TowerHelper {
  handleDrawingSubmit?: () => void;
  handleJokeSubmit?: (joke: string) => void;
}

interface TowerHelpers {
  [towerId: string]: TowerHelper;
}

// Create a global variable to store tower helpers
const globalTowerHelpers: TowerHelpers = {};

// Get a tower helper
export const getTowerHelper = (towerId: string): TowerHelper | undefined => {
  const helper = globalTowerHelpers[towerId];
  console.log(`Getting tower helper for ${towerId}:`, helper);
  return helper;
};

// Set a tower helper
export const setTowerHelper = (towerId: string, helper: TowerHelper): void => {
  console.log(`Setting tower helper for ${towerId}:`, helper);
  globalTowerHelpers[towerId] = helper;
};

// Set a drawing submit handler
export const setDrawingSubmitHandler = (towerId: string, handler: () => void): void => {
  console.log(`Setting drawing submit handler for tower ${towerId}`);
  if (!globalTowerHelpers[towerId]) {
    globalTowerHelpers[towerId] = {};
  }
  globalTowerHelpers[towerId].handleDrawingSubmit = handler;
};

// Set a joke submit handler
export const setJokeSubmitHandler = (towerId: string, handler: (joke: string) => void): void => {
  console.log(`Setting joke submit handler for tower ${towerId}`);
  if (!globalTowerHelpers[towerId]) {
    globalTowerHelpers[towerId] = {};
  }
  globalTowerHelpers[towerId].handleJokeSubmit = handler;
  
  // Debug verification
  console.log(`Joke handler registered for ${towerId}:`, globalTowerHelpers[towerId].handleJokeSubmit !== undefined);
};

// Clear a tower helper
export const clearTowerHelper = (towerId: string): void => {
  console.log(`Clearing tower helper for ${towerId}`);
  delete globalTowerHelpers[towerId];
};

// Clear a drawing submit handler
export const clearDrawingSubmitHandler = (towerId: string): void => {
  console.log(`Clearing drawing submit handler for tower ${towerId}`);
  if (globalTowerHelpers[towerId]) {
    globalTowerHelpers[towerId].handleDrawingSubmit = undefined;
  }
};

// Clear a joke submit handler
export const clearJokeSubmitHandler = (towerId: string): void => {
  console.log(`Clearing joke submit handler for tower ${towerId}`);
  if (globalTowerHelpers[towerId]) {
    globalTowerHelpers[towerId].handleJokeSubmit = undefined;
  }
}; 